import { useStoreState, useStoreActions } from 'easy-peasy'
import { legalTermsTypes } from 'utils/constants'
import { useEffect } from 'react'

export default function Contaner ({ children }) {
  const states = useStoreState(s => ({ legalTerms: s.legalTerms }))
  const actions = useStoreActions(a => ({ getLegalTerms: a.getLegalTerms, setLegalTerms: a.setLegalTerms }))

  useEffect(() => {
    actions.getLegalTerms({ type: legalTermsTypes.termsAndConditions.type })
    if (sessionStorage.getItem('redirectToLegalTerms')) {
      sessionStorage.removeItem('redirectToLegalTerms')
    }
  }, [])

  return children({ states })
}
